// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"b8bb258b","29":"ae8e88eb","172":"1fedaeaf","209":"fd8b0dc0","528":"f5776101","543":"b94fa2c3","919":"20a94059"}[chunkId] + ".chunk.js";
};